import React, { createRef } from "react";
import {
  Grid,
  Box,
  Typography,
  FormControl,
  Input,
  InputAdornment,
  Tooltip,
  Tab,
  Tabs,
  Divider,
} from "@mui/material";
import MapToolBar from "../../../components/MapData/MapToolBar";
import "./preMapData.scss";
import { bindActionCreators } from "redux";
import * as acts from "../../../redux/pre_processor/actions";
import { connect } from "react-redux";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import PdfICon from "../../../components/Icons/PdfIcon";
import ImageMapper from "react-img-mapper";
import PrismaZoom from "react-prismazoom";
import { CircularProgress } from "@mui/material";
import IconButton from "@mui/material/IconButton";
import AngleArrowLeft from "../../../assets/angle-circle-left-icon.svg";
import AngleArrowRight from "../../../assets/angle-circle-right-icon.svg";
import cloneDeep from "lodash/cloneDeep";
import TableSkeleton from "../../../components/Skeletons/TableSkeleton";
import TabelSelections from "./TabelSelections";
import SearchIcon from "@mui/icons-material/Search";
import MapDataTableParent from "./MapDataTableParent";
// import LazyLoad from "react-lazyload";

const CustomLeftArrow = ({ onClick }) => (
  <button
    onClick={() => onClick()}
    className="slick-prev"
    variant="contained"
    size="medium"
    color="primary"
  >
    Prev
  </button>
);
const CustomRightArrow = ({ onClick }) => {
  return (
    <button
      className="slick-next"
      onClick={() => onClick()}
      variant="contained"
      size="medium"
      color="primary"
    >
      Next
    </button>
  );
};

class MapData extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      coorData: [],
      selectedFile: {
        tagName: "",
        fileNo: 0, // index is considered as file
        pageNo: 0,
      },
      zoom: 1,
      prismaZoom: React.createRef(),
      allowZoom: true,
      responsive: {
        superLargeDesktop: {
          // the naming can be any, depends on you.
          breakpoint: { max: 4000, min: 3000 },
          items: 6,
        },
        desktop: {
          breakpoint: { max: 3000, min: 1024 },
          items: 4,
        },
        tablet: {
          breakpoint: { max: 1024, min: 464 },
          items: 3,
        },
        mobile: {
          breakpoint: { max: 464, min: 0 },
          items: 2,
        },
      },
      pageRotateAngle: 0,
      imageLoaded: false,
      selectedArea: {},
      areaIndex: null,
      data: [],
      sizes: [100, "30%", "auto"],
      showPageAfterDelay: false,
      isFullHeight: true,
      originalMapperWidth: 600,
      originalMapperHeight: 768,
      imageMapperWidth: 600,
      imageMapperHeight: 768,
      coorDataFromState: [],
      coorDataFromStateCopy: [],
      entireCoorDataFromResToState: [],
      selectionType: "coords",
      imageLoadedInDiv: false,
      inputValue: 0,
      showParameterTable: false,
      projectType: localStorage.getItem("projectType"),
    };
    this.checkIsImageLoadable = this.checkIsImageLoadable.bind(this);
    this.changeRef = createRef(); // Create a ref object for the child component
    // this.refreshRef = createRef(); // Create a ref object for the child component
    // this.child = React.createRef();
  }

  componentDidMount() {
    // if (this?.props?.isFullView) {
    //   this.setDataToState(this?.props?.coorData); // remove when sorting logic shifted to be
    //   const initialFileIndex = 0;
    //   this.checkIsImageLoadable(initialFileIndex, 0); // the second argument is current page number
    // }
    // if (!this?.props?.isFullView) {
    this.setDataToState(this?.props?.coorData); // remove when sorting logic shifted to be
    const initialFileIndex = 0;
    this.checkIsImageLoadable(initialFileIndex, 0); // the second argument is current page number
    // }
    this.props.acts.setSelectedFileDataForProUpdateMapping({});
    this.setShowParameterTable();

    // this.qcMapInterval = setInterval(() => {
    //   this.callQcMapData("save", true);
    // }, 120000); //2 min
  }

  componentWillUnmount() {
    clearInterval(this.qcMapInterval);
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.coorData !== this.props.coorData) {
      this.setDataToState(this.props.coorData);
    }

    // Update showParameterTable when projectType change
    if (prevState.projectType !== this.state.projectType) {
      this.setShowParameterTable();
    }
  }

  // Function to update showParameterTable
  setShowParameterTable = () => {
    const { projectType } = this.state;
    // const shouldShowTable = projectType.parameter_extraction;
    if (projectType === "parameter_extraction") {
      this.setState({ showParameterTable: true });
    } else if (projectType === "both") {
      this.setState({ showParameterTable: false });
    } else if (projectType === "qc_extraction") {
      this.setState({ showParameterTable: false });
    }
  };

  // UNSAFE_componentWillReceiveProps(nextProps) {
  //   this.setDataToState(nextProps?.coorData);
  // }

  setDataToState(coorData) {
    // used this to set first pdf selected in initial state  and temp setting some initialn data
    if (coorData.length > 0) {
      const initialFileIndex = 0;
      this.setState({
        selectedFile: {
          tagName: coorData[0]?.pdfName,
          fileNo: 0,
          pageNo: 0,
        },
      });

      if (coorData?.length) {
        let sortedCoorData = coorData;

        sortedCoorData.map((fileData, index) => {
          const sortedPagesData = fileData.pages.sort((a, b) => {
            return parseInt(a.pageNo) - parseInt(b.pageNo);
          });
          sortedCoorData[index]["pages"] = sortedPagesData;
        });

        this.setState({ data: { ...sortedCoorData[0]?.pages[0] } }); // initial page setting
        this.setState({
          dataCopy: cloneDeep(
            JSON.parse(JSON.stringify(sortedCoorData[0]?.pages[0]))
          ),
        }); // initial page setting
        this?.setState({ coorDataFromState: sortedCoorData });
        this.setState({ coorDataFromStateCopy: cloneDeep(sortedCoorData) });
        this.props.acts.setSelectedFileDataForProUpdateMapping({
          tagName: coorData[0]?.pdfName,
          fileNo: 0,
          pageNo: 0,
        });
      }

      this.checkIsImageLoadable(initialFileIndex, 0); // the second argument is current page number
    }
  }
  handleFileChange(tagName, index) {
    this.setState({
      selectedFile: {
        tagName: tagName,
        fileNo: index,
        pageNo: 0,
      },
      pageRotateAngle: 0,
      data: this?.state?.coorDataFromState[index]?.pages[0],
      imageMapperWidth: this?.state?.originalMapperWidth,
      imageMapperHeight: this?.state?.originalMapperHeight,
    });

    this?.state?.selectionType !== "coords" &&
      this.changeRef.current.onChangePdforPageWhenTableSelectin(); // Call the child function through the ref
    this.state.prismaZoom.current.reset();
    this.checkIsImageLoadable(index, 0);
    this.props.acts.setSelectedFileDataForProUpdateMapping({
      tagName: tagName,
      fileNo: index,
      pageNo: 0,
    });
  }

  handlePageChange = (value) => {
    this.setState({
      imageMapperWidth: this?.state?.originalMapperWidth,
      imageMapperHeight: this?.state?.originalMapperHeight,
    });
    if (value === "prev" && this.state.selectedFile?.pageNo !== 0) {
      const prevPageNo = parseInt(this.state.selectedFile?.pageNo) - 1;
      this.setState({
        selectedFile: {
          ...this.state.selectedFile,
          pageNo: prevPageNo,
        },
        pageRotateAngle: 0,
        data: this?.state?.coorDataFromState[this.state?.selectedFile?.fileNo]
          ?.pages[prevPageNo],
      });
      this.state.prismaZoom.current.reset();
      this.checkIsImageLoadable(this.state.selectedFile.fileNo, prevPageNo);
      this.props.acts.setSelectedFileDataForProUpdateMapping({
        ...this.state.selectedFile,
        pageNo: prevPageNo,
      });
    } else if (value === "next") {
      const nextPageNo = parseInt(this.state.selectedFile?.pageNo) + 1;

      this.setState({
        selectedFile: {
          ...this.state.selectedFile,
          pageNo: nextPageNo,
        },
        pageRotateAngle: 0,
        data: this?.state?.coorDataFromState[this.state?.selectedFile?.fileNo]
          ?.pages[nextPageNo],
      });
      this.state.prismaZoom.current.reset();
      this.checkIsImageLoadable(this.state.selectedFile.fileNo, nextPageNo);
      this.props.acts.setSelectedFileDataForProUpdateMapping({
        ...this.state.selectedFile,
        pageNo: nextPageNo,
      });
    }
    this?.state?.selectionType !== "coords" &&
      this.changeRef.current.onChangePdforPageWhenTableSelectin(); // Call the child function through the ref
  };

  searchPageClick = (value) => {
    if (
      value <
        this?.state?.coorDataFromState[this.state.selectedFile?.fileNo].pages
          .length &&
      value >= 0
    ) {
      this.setState({
        selectedFile: {
          ...this.state.selectedFile,
          pageNo: Number(value),
        },
        pageRotateAngle: 0,
        data: this?.state?.coorDataFromState[this.state?.selectedFile?.fileNo]
          ?.pages[Number(value)],
        imageMapperWidth: this?.state?.originalMapperWidth,
        imageMapperHeight: this?.state?.originalMapperHeight,
      });
      this.state.prismaZoom.current.reset();
      this.checkIsImageLoadable(this.state.selectedFile.fileNo, Number(value));
      this.props.acts.setSelectedFileDataForProUpdateMapping({
        ...this.state.selectedFile,
        pageNo: Number(value),
      });
    }
    this?.state?.selectionType !== "coords" &&
      this.changeRef.current.onChangePdforPageWhenTableSelectin(); // Call the child function through the ref
  };

  onClickZoom = (value) => {
    if (value === "out") {
      this.state.prismaZoom.current.zoomOut(1);
    } else {
      this.state.prismaZoom.current.zoomIn(1);
    }
  };

  onZoomChange = (zoom) => {
    this.setState({
      zoom: zoom,
    });
  };

  rotateClick = (value) => {
    if (value === "right") {
      this.setState({ pageRotateAngle: this.state.pageRotateAngle + 90 });
    }
    if (value === "left") {
      this.setState({ pageRotateAngle: this.state.pageRotateAngle - 90 });
    }
  };

  fitToScreenClick = () => {
    this.state.prismaZoom.current.reset();
    this.setState({
      pageRotateAngle: 0,
      imageMapperWidth: this?.state?.originalMapperWidth,
      imageMapperHeight: this?.state?.originalMapperHeight,
    });
  };

  checkIsImageLoadable = (fileIndex, pageNo) => {
    this.setState({ imageLoaded: false });
    if (this?.state?.coorDataFromState[fileIndex]?.pages[pageNo]?.imageUrl) {
      const objImg = new Image();
      objImg.src =
        this?.state?.coorDataFromState[fileIndex]?.pages[pageNo]?.imageUrl;
      objImg.onload = () => {
        this.setState({ imageLoaded: true });
      };
      objImg.onerror = () => {
        this.setState({ imageLoaded: true });
      };
    } else {
      this.setState({ imageLoaded: true });
    }
  };

  // onClickFooterAction = (action) => {
  //   if (action === "cancel") {
  //     this.props.navigate("/pre-processor-dashboard");
  //   } else if (action === "previous") {
  //     this.props.navigate("/upload-template-data");
  //   } else {
  //     this.props?.child.current.mapData(action);
  //   }
  // };

  clicked = (area, index, e) => {
    this.setState({
      selectedArea: area,
      areaIndex: index,
    });

    const dataToUpdate = this.state.data;
    dataToUpdate.areas[index] = {
      ...this.state.data.areas[index],
      preFillColor: "#ff00002e",
      fillColor: "#ff00002e",
    };
    this.setState({
      data: { ...dataToUpdate },
    });
  };

  onClickedFromTableSelection = (area, index, e) => {
    this.setState({
      selectedArea: area,
      areaIndex: index,
    });
  };

  onClickChangeOrientation = () => {
    this.setState({
      imageMapperWidth: this?.state?.imageMapperHeight,
      imageMapperHeight: this?.state?.imageMapperWidth,
    });
  };

  resetPdfHeighlights = () => {
    this?.setState({
      data: cloneDeep(this?.state?.dataCopy),
      coorDataFromState: cloneDeep(this?.state?.coorDataFromStateCopy),
    });
  };

  handleChange = (event) => {
    this?.setState({
      selectionType: event.target.value,
    });
  };

  // refresh = (e) => {
  //   this.refreshRef.current.refreshSelection(); // Call the child function through the ref
  // };

  handleImageLoad = () => {
    this.setState({ imageLoadedInDiv: true });
  };

  handleKeyDown = (e) => {
    if (e.key === "Enter") {
      this.searchPageClick(this.state.inputValue - 1);
    }
  };

  resestSelectedArea = () => {
    if (this.state.selectedArea)
      this.setState({
        selectedArea: {},
        areaIndex: null,
      });
    this?.state?.selectionType !== "coords" &&
      this.changeRef.current.onChangePdforPageWhenTableSelectin(); // Call the child function through the ref
  };

  onSubmitCrop = ({ selectedArea }) => {
    if (this.state.selectionType === "table") {
      this.setState({
        selectedArea: {
          coords: [
            selectedArea?.x,
            selectedArea?.y,
            selectedArea?.width,
            selectedArea?.height,
          ],
          selectionType: this.state.selectionType,
        },
      });
    }
  };

  handleTabChange = (event, newValue) => {
    this.setState({ showParameterTable: newValue === 1 }); // Set true for Parameter Table (Tab 1), false for QC Table (Tab 0)
  };

  // callQcMapData = (action, autoSave) => {
  //   this.props.acts.qcMapData({
  //     parametersData: this?.props?.qcParametersData,
  //     projectId: localStorage.projectId,
  //     next: action === "save" ? false : true,
  //     autosave: autoSave,
  //     isUpdateParameters: false,
  //     logs: [],
  //   });
  // };

  render() {
    return (
      <Box>
        {this.props?.coorData && this.props?.coorData?.length ? (
          <Box className="paddingBox">
            <Grid container className="wrap" spacing={1}>
              {this?.props?.hideScreen ? (
                <Grid xs={this?.props?.leftgrid} item>
                  {this.props?.coorData?.length > 0 ? (
                    <Box
                      className={
                        // this?.props?.isFullView ? "container-2" : "container-1"
                        "container-1"
                      }
                    >
                      <Grid className="premap-pdf-head">
                        <Grid item xs={9}>
                          <div className="ac-processor-pdf-slider-body">
                            <section>
                              <div>
                                <Carousel
                                  ssr
                                  // partialVisible
                                  deviceType={this.props.deviceType}
                                  itemClass="image-item"
                                  responsive={this.state.responsive}
                                  customRightArrow={<CustomRightArrow />}
                                  customLeftArrow={<CustomLeftArrow />}
                                >
                                  {this?.state?.coorDataFromState?.map(
                                    (file, index) => {
                                      const label = file.pdfName;
                                      const truncatedLabel =
                                        label.length > 6
                                          ? label.slice(0, 6) + "..."
                                          : label;
                                      const tooltipLabel =
                                        label.length > 6 ? label : "";
                                      return (
                                        <div
                                          className={
                                            this.state.selectedFile?.fileNo ===
                                            index
                                              ? "ac-processor-slider-content selectedPDF"
                                              : "ac-processor-slider-content"
                                          }
                                          onClick={() =>
                                            this.handleFileChange(
                                              file.pdfName,
                                              index
                                            )
                                          }
                                        >
                                          <PdfICon className="pdf-icon" />

                                          <Tooltip title={tooltipLabel}>
                                            <Typography
                                              sx={{ marginLeft: "4px" }}
                                              variant="caption"
                                              display="block"
                                            >
                                              {truncatedLabel}
                                            </Typography>
                                          </Tooltip>
                                        </div>
                                      );
                                    }
                                  )}
                                </Carousel>
                              </div>
                            </section>
                          </div>
                        </Grid>

                        <Grid item xs={4} className="arrow-angle-grid">
                          {/* <Grid item xs={4} className="arrow-angle-grid"> */}

                          {/* {this.props?.is_template_uploaded === false && (
                        <Tooltip title="Selection Type" arrow placement="top">
                          <FormControl
                            variant="standard"
                            size="small"
                          >
                            <div
                            >
                              <Select
                                labelId="demo-simple-select-standard-label"
                                id="demo-simple-select-standard"
                                value={this?.state?.selectionType}
                                onChange={this?.handleChange}
                              >
                                <MenuItem value={"coords"}>Coords</MenuItem>
                                 comment this <MenuItem value={"table"}>Table</MenuItem> 
                                <MenuItem value={"page"}>Words</MenuItem>
                              </Select>
                              {this?.state?.selectionType !== "coords" && (
                                <IconButton aria-label="delete" size="small">
                                  <AutorenewIcon
                                    onClick={() => this?.refresh()}
                                  />
                                </IconButton>
                              )}
                            </div>
                          </FormControl>
                        </Tooltip>
                      )} */}

                          <div>
                            <FormControl
                              className="standard-adornment-password"
                              variant="standard"
                            >
                              <Input
                                type="number"
                                id="stan  dard-adornment-password"
                                onKeyDown={this.handleKeyDown} // Add the event listener here
                                onChange={(e) =>
                                  this.setState({ inputValue: e.target.value })
                                }
                                placeholder="Page"
                                className="p-0"
                                endAdornment={
                                  <InputAdornment
                                    position="end"
                                    className="pass-visibility"
                                  >
                                    <IconButton
                                      aria-label="toggle password visibility"
                                      onClick={() =>
                                        this.searchPageClick(
                                          this.state.inputValue - 1
                                        )
                                      }
                                      className="p-2"
                                    >
                                      <SearchIcon />
                                    </IconButton>
                                  </InputAdornment>
                                }
                              />
                            </FormControl>
                          </div>

                          <div>
                            <div className="text-center">
                              <div className="arrow-angle-container">
                                <IconButton
                                  className={
                                    parseInt(this.state.selectedFile?.pageNo) +
                                      1 <=
                                    1
                                      ? "arrow-angle-condition"
                                      : "arrow-angle-condition2"
                                  }
                                  onClick={(e) =>
                                    this.state.selectedFile?.pageNo !== 0 &&
                                    this?.handlePageChange("prev")
                                  }
                                >
                                  <img
                                    className="arrow-angle-left"
                                    src={AngleArrowLeft}
                                    alt="prev page"
                                  />
                                </IconButton>
                                <IconButton
                                  className={
                                    parseInt(
                                      this.state.selectedFile?.pageNo + 1
                                    ) >=
                                    this?.state?.coorDataFromState[
                                      this.state.selectedFile?.fileNo
                                    ]?.pages?.length
                                      ? "arrow-angle-condition"
                                      : "arrow-angle-condition2"
                                  }
                                  onClick={(e) =>
                                    parseInt(this.state.selectedFile?.pageNo) +
                                      1 !==
                                      this?.state?.coorDataFromState[
                                        this.state.selectedFile?.fileNo
                                      ]?.pages?.length &&
                                    this?.handlePageChange("next")
                                  }
                                >
                                  <img
                                    className="arrow-angle-right"
                                    src={AngleArrowRight}
                                    alt="next page"
                                  />
                                </IconButton>
                              </div>
                              <>
                                <Typography className="arrow-angle-page-text">{`Page ${
                                  parseInt(this.state.selectedFile?.pageNo) + 1
                                }/ ${
                                  this?.state?.coorDataFromState[
                                    this.state.selectedFile?.fileNo
                                  ]?.pages?.length
                                }`}</Typography>
                              </>
                            </div>
                          </div>

                          <div>
                            <MapToolBar
                              file={
                                this?.state?.coorDataFromState[
                                  this.state.selectedFile?.fileNo
                                ]
                              }
                              handlePageChange={this.handlePageChange}
                              selectedFile={this.state.selectedFile}
                              searchPageClick={this.searchPageClick}
                              onClickZoom={this.onClickZoom}
                              zoom={this.state.zoom}
                              rotateClick={this.rotateClick}
                              fitToScreenClick={this.fitToScreenClick}
                              onClickChangeOrientation={
                                this.onClickChangeOrientation
                              }
                            />
                          </div>
                          {/* </Grid> */}
                        </Grid>
                      </Grid>

                      <Grid className="view_pdf" md={12}>
                        <div
                          id="container"
                          style={{
                            transform: `rotate(${this.state.pageRotateAngle}deg)`,
                            transition: "transform 150ms ease", // smooth transition
                            cursor: "grab",
                            left: [
                              90, 270, 450, 630, 810, 990, 1170, 1350, 1530,
                              1710, 1890,
                            ].includes(this.state.pageRotateAngle)
                              ? "14%"
                              : 0,
                            position: "relative",
                          }}
                        >
                          <PrismaZoom
                            minZoom={1}
                            maxZoom={10}
                            animDuration={0.5}
                            allowZoom={this.state.allowZoom}
                            ref={this.state.prismaZoom}
                            onZoomChange={this.onZoomChange}
                          >
                            {this.state?.imageLoaded ? (
                              this?.state?.selectionType === "table" ||
                              this?.state?.selectionType === "page" ? (
                                <TabelSelections
                                  imageData={this?.state?.data}
                                  selectionType={this?.state?.selectionType}
                                  imageMapperWidth={
                                    this?.state?.imageMapperWidth
                                  }
                                  imageMapperHeight={
                                    this?.state?.imageMapperHeight
                                  }
                                  onClicked={(area, index, e) =>
                                    this.onClickedFromTableSelection(
                                      area,
                                      index,
                                      e
                                    )
                                  }
                                  onSubmitCrop={this.onSubmitCrop}
                                  ref={this.changeRef}
                                  // ref2={this.refreshRef}
                                />
                              ) : (
                                <>
                                  <img
                                    alt="Map_Image"
                                    src={this.state?.data?.imageUrl}
                                    onLoad={this.handleImageLoad}
                                    className="d-none"
                                    // loading="lazy"
                                  />
                                  {this.state.imageLoadedInDiv ? ( // this logoc is added due to very initial time bounding box is not appearing
                                    // <LazyLoad height={200} offset={100}>
                                    <ImageMapper
                                      disabled
                                      src={this.state?.data?.imageUrl}
                                      map={this.state?.data}
                                      width={this?.state?.imageMapperWidth}
                                      height={this?.state?.imageMapperHeight}
                                      // onClick={(area, index, e) =>
                                      //   this.clicked(area, index, e)
                                      // }
                                      imgWidth={this?.state?.imageMapperWidth}
                                      natural={true}
                                      responsive={true}
                                      parentWidth={
                                        this?.state?.imageMapperWidth
                                      }
                                    />
                                  ) : (
                                    // </LazyLoad>
                                    <Box className="premap-loader-container">
                                      <CircularProgress />
                                      <span className="premap-loader-style">
                                        Loading...
                                      </span>
                                    </Box>
                                  )}
                                </>
                              )
                            ) : (
                              <Box className="premap-loader-container">
                                <CircularProgress />
                                <span className="premap-loader-style">
                                  Loading...
                                </span>
                              </Box>
                            )}
                          </PrismaZoom>
                        </div>
                      </Grid>
                    </Box>
                  ) : (
                    <TableSkeleton />
                  )}
                </Grid>
              ) : (
                <></>
              )}

              <Grid xs={this?.props?.rightgrid} item>
                <Box>
                  <Box
                    className={
                      // this?.props?.isFullView ? "container-2" : "container-1"
                      "container-1"
                    }
                    noValidate
                    autoComplete="off"
                  >
                    <Tabs
                      size="small"
                      value={this.state.showParameterTable ? 1 : 0} // 0 for QC Table, 1 for Parameter Table
                      onChange={this.handleTabChange}
                      // centered
                      TabIndicatorProps={{
                        style: {
                          marginBottom: "2px", // Adds some space between the indicator and the tab text
                        },
                      }}
                      sx={{
                        minHeight: "35px", // Set minimum height for the Tabs component
                        height: "38px", // Set fixed height for the Tabs component
                        paddingTop: "5px",
                        paddingLeft: "20px",
                      }}
                    >
                      {/* QC Table Tab */}
                      <Tab
                        label="QC Table"
                        sx={{
                          backgroundColor: !this.state.showParameterTable
                            ? "#1976d2"
                            : "",
                          color: !this.state.showParameterTable
                            ? "#ffff !important"
                            : "",
                          transition: "background-color 0.3s",
                          minHeight: "20px",
                          padding: "5px 10px",
                          fontSize: "0.875rem",
                          borderRadius: "6px",
                          marginRight: 1,
                        }}
                        disabled={
                          this.state?.projectType === "parameter_extraction"
                        }
                      />

                      {/* Parameter Table Tab */}
                      <Tab
                        label="Extraction"
                        className="mapping_toggle_tab"
                        sx={{
                          backgroundColor: this.state.showParameterTable
                            ? "#1976d2"
                            : "",
                          color: this.state.showParameterTable
                            ? "#ffff !important"
                            : "",
                          transition: "background-color 0.3s",
                          minHeight: "20px", // Decrease the height of the tab
                          padding: "5px 10px", // Padding to make it look smaller
                          fontSize: "0.875rem", // Smaller font size
                          borderRadius: "6px",
                        }}
                        disabled={this.state?.projectType === "qc_extraction"}
                      />
                    </Tabs>
                    <Divider />

                    <MapDataTableParent
                      showParameterTable={this?.state?.showParameterTable}
                      is_template_uploaded={this.props?.is_template_uploaded}
                      selectedFile={this.state?.selectedFile}
                      selectedArea={this.state?.selectedArea}
                      parametersData={this.props?.parametersData}
                      // ref={this.child}
                      role="preProcessor"
                      reProcess={this?.props?.reProcess}
                      isDataRejectedByProcessor={
                        this?.props?.isDataRejectedByProcessor
                      }
                      isDataRejectedByValidator={
                        this?.props?.isDataRejectedByValidator
                      }
                      // isFullView={this?.props?.isFullView}
                      resetPdfHeighlights={this?.resetPdfHeighlights}
                      entireBatchRejectedByPro={
                        this?.props?.entireBatchRejectedByPro
                      }
                      showContextMenu={false}
                      resestSelectedArea={this.resestSelectedArea}
                      areaIndex={this.state?.areaIndex}
                      columnsCount={this.props?.columnsCount}
                      isDisableOnChangeInput={true}
                      isDisableOnBlur={true}
                      // qcTemplateData={this.props?.qcTemplateData}
                      // footer data
                      isDisableMultipageMappingLable={true}
                      isShowReject={false}
                      isPrevious={true}
                      disableSaveAndNext={
                        this.state.projectType === "both" &&
                        this.state.showParameterTable === false
                      }
                      props={this.props}
                      projectType={this.state.projectType}
                    />
                    {/* {this?.state?.showParameterTable === true ? (
                      // <Box
                      //   sx={{
                      //     display: this.state.showParameterTable
                      //       ? "block"
                      //       : "none",
                      //   }}
                      // >
                      // {
                      this.props?.is_template_uploaded === true ? (
                        <MapDataTable
                          selectedFile={this.state?.selectedFile}
                          selectedArea={this.state?.selectedArea}
                          parametersData={this.props?.parametersData}
                          ref={this.child}
                          role="preProcessor"
                          reProcess={this?.props?.reProcess}
                          isDataRejectedByProcessor={
                            this?.props?.isDataRejectedByProcessor
                          }
                          isDataRejectedByValidator={
                            this?.props?.isDataRejectedByValidator
                          }
                          // isFullView={this?.props?.isFullView}
                          resetPdfHeighlights={this?.resetPdfHeighlights}
                          entireBatchRejectedByPro={
                            this?.props?.entireBatchRejectedByPro
                          }
                          showContextMenu={false}
                          resestSelectedArea={this.resestSelectedArea}
                        />
                      ) : this.props?.is_template_uploaded === false ? (
                        <CNCTableWrapper
                          selectedFile={this.state?.selectedFile}
                          selectedArea={this.state?.selectedArea}
                          areaIndex={this.state?.areaIndex}
                          ref={this.child}
                          role="preProcessor"
                          parametersData={this.props?.parametersData}
                          columnsCount={this.props?.columnsCount}
                          reProcess={this?.props?.reProcess}
                          isDataRejectedByProcessor={
                            this?.props?.isDataRejectedByProcessor
                          }
                          isDataRejectedByValidator={
                            this?.props?.isDataRejectedByValidator
                          }
                          // isFullView={this?.props?.isFullView}
                          showContextMenu={false}
                          isDisableOnChangeInput={true}
                          isDisableOnBlur={true}
                          resetPdfHeighlights={this?.resetPdfHeighlights}
                          entireBatchRejectedByPro={
                            this?.props?.entireBatchRejectedByPro
                          }
                          resestSelectedArea={this.resestSelectedArea}
                        />
                      ) : (
                        <TableSkeleton />
                      )
                    ) : (
                      // </Box>
                      // <Box
                      //   sx={{
                      //     display: this.state.showParameterTable
                      //       ? "none"
                      //       : "block",
                      //   }}
                      // >
                      <QCTable
                        role="preProcessor"
                        selectedFile={this.state?.selectedFile}
                        qcTemplateData={this.props?.qcTemplateData}
                        // ref={this.props?.qcChild}
                        // isFullView={this?.props?.isFullView}
                      />
                    )} */}
                    {/* </Box> */}
                  </Box>
                </Box>
              </Grid>
            </Grid>
          </Box>
        ) : (
          <Grid container spacing={2}>
            <Grid item xs={this?.props?.leftgrid}>
              <TableSkeleton />
            </Grid>
            <Grid item xs={this?.props?.rightgrid}>
              <TableSkeleton />
            </Grid>
          </Grid>
        )}

        {/* <MapFooter
          // pdfCount={this.props?.coorData.length}
          isDisableMultipageMappingLable={true}
          onClickFooterAction={this.onClickFooterAction}
          isShowReject={false}
          isPrevious={true}
          disableSaveAndNext={
            this.state.projectType === "both" &&
            this.state.showParameterTable === false
          }
        /> */}
      </Box>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    acts: bindActionCreators(acts, dispatch),
  };
};

function mapStateToProps(state) {
  return {
    coorData: state?.prePro?.coorData?.coordinatesDetails || [],
    parametersData:
      state?.prePro?.coorData?.mapping_details?.parametersData || [],
    is_template_uploaded: state?.prePro?.coorData?.is_template_uploaded,
    is_op_uploaded: state?.prePro?.coorData?.is_op_format_uploaded,
    columnsCount: state?.prePro?.coorData?.mapping_details?.columnsCount,
    proRowRejectionData:
      state?.prePro?.coorData?.mapping_details?.proRowRejectionData,
    reProcess: state?.prePro?.coorData?.mapping_details?.reProcess,
    isDataRejectedByProcessor:
      state?.prePro?.coorData?.mapping_details?.isDataRejectedByProcessor,
    isDataRejectedByValidator:
      state?.prePro?.coorData?.mapping_details?.isDataRejectedByValidator,
    validatorRowRejectionData:
      state?.prePro?.coorData?.mapping_details?.validatorRowRejectionData,
    entireBatchRejectedByPro:
      state?.prePro?.coorData?.mapping_details?.entireBatchRejectedByPro,

    // qcTemplateData:
    //   state?.prePro?.coorData?.qc_mappingDetails?.templateData || [],
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(MapData);
